import { Controller } from "@hotwired/stimulus"

// Hides the download-the-app banner for a month (AppDownloadBannerHelper::DISMISS_COOKIE).
export default class extends Controller {
  dismiss() {
    document.cookie = `app_download_banner_dismissed=1; path=/; max-age=${60 * 60 * 24 * 30}; samesite=lax`
    this.element.remove()
  }
}
